import { jsx as _ } from "react/jsx-runtime";
import { createContext as k, forwardRef as q, useRef as U, useMemo as f } from "react";
import { o as $, b as y, f as z, s as G, c as X, d as B, e as J, g as K, h as L, i as Q, j as W } from "../../floating-ui.react-SmaXvp4L.js";
import { POPOVER_USE_MAX_HEIGHT as Y } from "./Popover.types.js";
import { usePopoverState as Z } from "./hooks/usePopoverState.js";
import { usePopoverNavigation as A } from "./hooks/usePopoverNavigation.js";
import { usePopoverAria as T } from "./hooks/usePopoverAria.js";
import { usePopoverImperativeHandle as D } from "./hooks/usePopoverImperativeHandle.js";
import { focusableElements as ee } from "../../helpers/dom/focusableElements.js";
const oe = k(
  void 0
), te = q(
  ({
    align: x,
    children: I,
    defaultShow: E,
    disabledAutoToggle: n,
    focusStartIndex: R,
    matchActivatorWidth: P,
    onActivated: c,
    onDeactivated: m,
    onNavigate: S,
    type: i,
    show: b,
    virtualFocus: u
  }, g) => {
    const p = x === "auto", h = U(null), r = Z({
      defaultShow: E,
      show: b
    }), M = f(() => {
      const e = [
        $(5),
        p ? y() : z(),
        G()
      ];
      return P && e.push(
        X({
          apply({ rects: s, availableHeight: t, elements: V }) {
            requestAnimationFrame(() => {
              Object.assign(V.floating.style, {
                width: `${s.reference.width}px`,
                maxHeight: t > Y ? `${t}px` : void 0
              });
            });
          },
          padding: 5
        })
      ), e;
    }, [p, P]), o = B({
      open: r.show,
      onOpenChange: (e, s, t) => {
        r.setShow(e), e ? c == null || c(s, t, a) : m == null || m(s, t, a);
      },
      middleware: M,
      placement: p ? void 0 : x,
      whileElementsMounted: W
    }), N = J(o.context, {
      enabled: !n
    }), j = K(o.context, {
      enabled: !n
    }), F = L(o.context, {
      role: i
    }), { activeIndex: a, list: d, listNav: H, setActiveIndex: v } = A(
      o.context,
      i,
      {
        focusItemOnOpen: !0,
        virtual: u
      },
      S,
      R
    ), l = T(), w = Q([N, j, F, H]), O = f(() => u ? {
      getVirtualFocus: () => h.current,
      setVirtualFocus: (e) => {
        h.current = e;
      }
    } : {}, [u]), C = f(
      () => ({
        ...l,
        ...r,
        ...O,
        api: o,
        activeIndex: a,
        disabledAutoToggle: n,
        getFocusableActivator: () => {
          const e = o.elements.reference;
          return (e == null ? void 0 : e.querySelector("[role=combobox]")) ?? ee(e)[0];
        },
        interactions: w,
        list: d,
        setActiveIndex: v,
        setShowWithReason: (e, s, t) => o.context.onOpenChange(e, s, t),
        type: i
      }),
      [
        a,
        o,
        l,
        n,
        w,
        d,
        v,
        r,
        i,
        O
      ]
    );
    return D(g, o, l, r, C), /* @__PURE__ */ _(oe.Provider, { value: C, children: I });
  }
);
te.displayName = "PopoverProvider";
export {
  oe as PopoverContext,
  te as PopoverProvider
};
